/**
 * Fetch Roadmap UseCase
 *
 * Thin delegator for the paginated roadmap (Ideas) list. Forwards the
 * pagination cursor to `roadmapService.fetchRoadmap` and returns its result
 * unchanged ({ items, hasMore, cursor }). No business logic lives here — the
 * DTO→entity mapping and like-state fill stay in the service.
 *
 * Flutter parity:
 *  - lib/presentation/screens/roadmap/roadmap_screen.dart:417-422 (_getData,
 *    the `itemInfo == null` branch): RoadmapRepository().getRoadmap(
 *    _lastFetchedItem, AppConstants.roadmapListPagination). The page size lives
 *    in firestoreService.getRoadmap (Task 2); this use case only forwards the
 *    cursor and surfaces the page.
 */

import { roadmapService } from '@/domain/services/roadmap/roadmapService';
import type { RoadmapPage } from '@/domain/services/roadmap/roadmapService';
import type { PageCursor } from '@/data/types/json';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';

export class FetchRoadmapUseCase {
  async execute(cursor?: PageCursor): Promise<RoadmapPage> {
    return roadmapService.fetchRoadmap(SERVER_FETCH_CONSTANTS.DEFAULT_LIMIT, cursor);
  }
}

export const fetchRoadmapUseCase = new FetchRoadmapUseCase();
